export default __webpack_public_path__ + "static/jakubw-7d30813bd2b04143cbea0c5f2107ad03.png";